export default __webpack_public_path__ + "static/fattoQuotidiano2-c89b746f792a7a9049b7e3964c1a262e.svg";